import { Fancybox } from "@fancyapps/ui";

function resumeBackgroundVideo() {
  // Resume background Vimeo video
  var vimeoEl = document.querySelector('[data-vimeo-bg-init]');
  if (vimeoEl) {
    var iframe = vimeoEl.querySelector('iframe');
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
    }
  }

  // Resume background YouTube video
  var youtubeEl = document.querySelector('[data-youtube-bg-init]');
  if (youtubeEl) {
    var iframe = youtubeEl.querySelector('iframe');
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
    }
  }
}

export default function initFancybox() {
  Fancybox.bind('[data-fancybox]', {
    dragToClose: false,
    on: {
      close: resumeBackgroundVideo,
      destroy: resumeBackgroundVideo,
    }
  });
}

